export default __webpack_public_path__ + "static/media/Iceland-1.3fd19f1f.webp";